import AutoSubmit from "../components/AutoSubmit";
import BulkAction from "../components/BulkAction";

export default class PublicationJobsManagedLists {
  constructor(params) {
    this.params = params;
  }

  new() {
    this.bindSubmitOnFileSelect();
    this.bindContinue();

    if (this.params.failed) {
      $(".js-address-upload-failed-modal").modal();
      $(".modal-backdrop").addClass("in");
    }
  }

  show() {
    /* eslint-disable no-new, new-cap */
    new AutoSubmit();
    new BulkAction({
      target: "#addresses-bulk-store",
      action: "#addresses-bulk-action",
      secondary_nav: "#addresses-action-bar",
      checked_scope: "td",
    });

    new N2Styles.searchBar({
      safeContainer: ".js-table-search",
      showSelector: ".show-table-search",
      visible: this.params.search,
    });

    this.bindDisabledToasts();
    /* eslint-enable no-new, new-cap */
  }

  bindContinue() {
    N2.handle("click", ".js-managed-list-submit", () => {
      if ($("#managed_mailing_list_kind_auto")[0].checked) {
        new N2Styles.modalOpener($("#query-count-modal")); // eslint-disable-line no-new, new-cap
      } else if ($("#managed_mailing_list_kind_manual")[0].checked) {
        $("[data-js-file]").click();
      } else {
        new N2Styles.toast("Please pick an option"); // eslint-disable-line no-new, new-cap
      }
    });
  }

  // For disabled controls on the address list, show a toast explaining why
  // they can't be used and make sure it doesn't spam the screen if they try to
  // click multiple times / multiple elements.
  bindDisabledToasts() {
    N2.handle("click", ".disabled, [disabled]", () => {
      if (this.toasting) { return; }
      this.toasting = true;
      new N2Styles.toast("That action is only available when this publication is in Waiting status."); // eslint-disable-line no-new, new-cap
      setTimeout(() => {
        this.toasting = false;
      }, 5000);
    });
  }

  bindSubmitOnFileSelect() {
    N2.handle("change", "[data-js-file]", (evt) => {
      const field = $(evt.currentTarget);
      if (field.val() != null) {
        N2.showProgressIndicator();
        field.closest("form").submit();
      }
    });
  }
}
